import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const boletinesApi = `${baseUrl}/boletines`;

export const allBoletinesService = async (params) => {
  try {
    const res = await axios.get(`${boletinesApi}`, {
      headers: token({}),
      params,
    });
    return res;
  } catch (e) {
    console.log(e);
  }
};

export const oneBoletinesService = async (id) => {
  try {
    const res = await axios.get(`${boletinesApi}/${id}`, {
      headers: token({}),
    });
    return res;
  } catch (e) {
    console.log(e);
  }
};
